// Copyright (c) Proto Labs, Inc. All Rights Reserved.
class UrlUtility {
    getDomain(url) {
        const hostname = this.getHostname(url);
        if (!hostname) {
            return '';
        }
        const splitHostName = hostname.split('.');
        if (splitHostName.length >= 2) {
            const secondToLastPieceOfDomain = splitHostName[splitHostName.length - 2];
            const lastPieceOfDomain = splitHostName[splitHostName.length - 1];
            return `${secondToLastPieceOfDomain}.${lastPieceOfDomain}`;
        }
        return '';
    }
    isAuthenticatedDomain(url, unauthenticatedDomains = []) {
        if (!url || url.length === 0) {
            return true;
        }
        const hostname = this.getHostname(url);
        if (url.includes('AWSAccessKeyId')) {
            return false;
        }
        if (!hostname) {
            return true;
        }
        if (unauthenticatedDomains.includes(hostname)) {
            return false;
        }
        for (const authDomain of UrlUtility.AuthenticatedDomains) {
            if (hostname.endsWith(authDomain)) {
                return true;
            }
        }
        return false;
    }
    getHostname(url) {
        try {
            const cleansedUrl = url.replace(/(\t|\r\n|\n|\r)/gm, '');
            const parsedUrl = new URL(cleansedUrl);
            return parsedUrl.hostname.toLowerCase();
        }
        catch {
            return '';
        }
    }
}
UrlUtility.AuthenticatedDomains = [
    'localhost',
    'prlb.online',
    'protolabs.io',
    'protolabs.com',
    'protolabs.co.uk',
];
export { UrlUtility };
//# sourceMappingURL=UrlUtility.js.map